import React from 'react';
import SPAPill, { SPAPillTone } from '@/components/admin/SysadminSPA/shared/SPAPill';

const TONES: Record<string, SPAPillTone> = {
  Content: 'accent',
  Edit: 'warning',
  Final: 'success',
  Pair: 'warning',
  Prod: 'info',
  Review: 'warning',
};

const StatusPill = ({ status }: { status: string }) => (
  <SPAPill tone={TONES[status] ?? 'neutral'}>{status}</SPAPill>
);

export default StatusPill;
